import React from 'react';
import { useB2BTranslation } from '../hooks/useB2BTranslation';
import { Edit3 } from 'lucide-react';
import { Link } from 'react-router-dom';
import './B2BEditProfileButton.css';

interface B2BEditProfileButtonProps {
  to: string;
  state?: any;
  className?: string;
  size?: 'small' | 'medium' | 'large';
  variant?: 'primary' | 'secondary' | 'outline';
  showIcon?: boolean;
  disabled?: boolean;
  children?: React.ReactNode;
}

const B2BEditProfileButton: React.FC<B2BEditProfileButtonProps> = ({
  to,
  state,
  className = '',
  size = 'medium',
  variant = 'primary',
  showIcon = true,
  disabled = false,
  children
}) => {
  const { t } = useB2BTranslation();
  
  const buttonClasses = `b2b-edit-profile-button b2b-edit-profile-button--${size} b2b-edit-profile-button--${variant} ${className}`;

  return (
    <Link
      to={to}
      state={state}
      className={buttonClasses}
      style={{ pointerEvents: disabled ? 'none' : 'auto' }}
    >
      {showIcon && <Edit3 size={16} aria-hidden="true" />}
      {children || t('buttons.editProfile')}
    </Link>
  );
};

export default B2BEditProfileButton;


